module.exports = __webpack_public_path__ + "static/media/EcTravel.68dd1246.jpg";